export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/go-icon.svg?d23a4b881abf2128ae246ab1ef33636a";